import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  BehaviorSubject, map } from 'rxjs';
import { environment } from '../../environment/environment';
import { restEndPoints } from '../app.constants';
import { ICategories } from '../components/dashboard/dashboard.model';

@Injectable({
  providedIn: 'root',
})

export class CommonService {

  setCategories(categories: ICategories[]) {
    return categories;
  }

  baseUrl = environment.apiHost;
  authToken: string | null = '';
  allCategories$ = new BehaviorSubject<ICategories[]>([]); 
  
  constructor(private httpClient: HttpClient) { }
  
  getCategories(companyId: number | null) {
    let url = `${this.baseUrl}${restEndPoints.shared.getAllCategories}/${companyId}`
    return this.httpClient.get(`${url}`).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
        this.allCategories$.next(response.value);
            return response.value;
        } else {
          throw new Error('Error fetching data');
        }
      }))
  }

  // Method to get category counts with query parameters and headers
  getStores(companyId: number | null) {
    let url = `${this.baseUrl}${restEndPoints.shared.getAllBookingSores}/${companyId}`
    return this.httpClient.get(`${url}`).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          throw new Error('Error fetching data');
        }
      }))
  }


  // Method to get category counts with query parameters and headers
  getStatuses() {
    let url = `${this.baseUrl}${restEndPoints.shared.getAllBookingStatuses}`
    return this.httpClient.get(`${url}`).pipe(
      map((response: any) => {
        // Handle the response, extract value if no error
        if (!response.isError) {
          return response.value;
        } else {
          throw new Error('Error fetching data');
        }
      }))
  }

  //Display respective name for the retreived status id
  getStatusClass(statusName: string): string {
    switch (statusName) {
      case 'In progress':
        return 'in-progress';
      case 'Scheduled':
        return 'scheduled';
      case 'Cancelled':
        return 'cancelled';
      case 'Completed':
        return 'completed';
      case 'Warranty':
        return 'warranty';
      default:
        return '';
    }
  }

  //Attach Icons for Status
  getStatusIcon(statusName: string): string {
    if (!statusName) {
      return '/assets/images/icons-kpi-dashboard/default-icon.png'; // Default icon if status is not available
    }
    switch (statusName) {
      case 'In progress':
        return './../../../../assets/images/icons-kpi-dashboard/icons/in-progress-icon.png';
      case 'Scheduled':
        return './../../../../assets/images/icons-kpi-dashboard/icons/scheduled-icon.png';
      case 'Cancelled':
        return './../../../../assets/images/icons-kpi-dashboard/icons/cancelled-icon.png';
      case 'Completed':
        return './../../../../assets/images/icons-kpi-dashboard/icons/completed-icon.png';
      case 'Warranty':
        return './../../../../assets/images/icons-kpi-dashboard/icons/warranty-icon.png';
      default:
        return './../../../../assets/images/icons/icons-kpi-dashboard/default-icon.png';  // Default icon for unknown status
    }
  }

  filterDates(d:Date | null) : boolean{
    const today = new Date()
    if(d === null) return false
    return d <= today;
  }
}